import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { HelpCircle } from 'lucide-react';
export function HairTypeTest() {
  return <section className="py-20 bg-cream-100 relative overflow-hidden" data-id="element-80">
      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-81">
        <FadeIn className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-brown-900/5" data-id="element-82">
          <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-83">
            <div className="shrink-0 bg-rose-muted/10 p-4 rounded-full" data-id="element-84">
              <HelpCircle className="w-12 h-12 text-rose-muted" data-id="element-85" />
            </div>

            <div className="space-y-6" data-id="element-86">
              <h2 className="text-3xl md:text-4xl font-serif text-brown-900" data-id="element-87">
                ¿Y si no sé mi tipo?
              </h2>

              <div className="space-y-4 text-lg text-brown-800 leading-relaxed" data-id="element-88">
                <p data-id="element-89">
                  Por eso existe el test rápido al inicio. No vas a necesitar
                  ser experta. Vas a necesitar ser honesta.
                </p>
                <p className="font-medium text-brown-900 bg-cream-50 p-6 rounded-xl border-l-4 border-rose-muted" data-id="element-90">
                  Si dudas entre dos tipos, te digo exactamente qué hacer:{' '}
                  <br data-id="element-91" />
                  <span className="italic" data-id="element-92">
                    elige el más "rizado" por 14 días, evalúa con checklist, y
                    ajustas. Sin drama.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}